module.exports = __webpack_public_path__ + "discount.svg?05c04a801d694cdd13153589c8f67200";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/discount.svg
// module id = 285
// module chunks = 2